
            const data = {"name":"glyph/24/ctrl-left","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m15.191 23.588-8-11a1 1 0 0 1 0-1.176l8-11 1.617 1.176L9.236 12l7.572 10.412-1.617 1.176z\" class=\"nc-icon-wrapper\" _fill=\"#272c33\"/>","originalColors":[{"type":"fill","color":"#272c33"}],"stopColors":[]}}
        
                    module.exports = data
                    